import React from "react";
type CarouselDotsProps = {
  count: number;
  index: number;
  onSelect: (i: number) => void;
  inverted?: boolean;
};
export function CarouselDots({
  count,
  index,
  onSelect,
  inverted = false
}: CarouselDotsProps) {
  return <div className="mt-4 flex justify-center gap-1.5 md:hidden" data-id="element-51" data-mp="22tt8rt77duq1">
      {Array.from({
      length: count
    }).map((_, i) => <button key={i} type="button" aria-label={`Ir al elemento ${i + 1}`} aria-current={i === index} onClick={() => onSelect(i)} className={`h-1.5 rounded-full transition-[width,background-color] duration-200 ease-out ${i === index ? `w-6 ${inverted ? "bg-gold" : "bg-forest"}` : `w-1.5 ${inverted ? "bg-paper/30" : "bg-line"}`}`} data-id="element-52" data-mp="1yq53jh61nb7y" data-mpi={i} />)}
    </div>;
}